/**------------- Block Quote constants -------------**/

/*  General  */
export const BLOCK_QUOTE_CLASS_NAME = "block-quote";
